<template>
  <div class="item" data-test-id="AppLogoutButton" @click="showModal">
    <BaseIcon name="exit_to_app" size="24" />
    <span>Wyloguj się</span>
  </div>

  <BaseModal v-if="modalVisible" @close="closeModal">
    <template #title>Wylogowanie</template>
    Czy na pewno chcesz się wylogować?

    <template #actions>
      <StyledButton variant="outline" component-name="CancelLogoutButton" @click="closeModal">
        Anuluj
      </StyledButton>
      <StyledButton component-name="ConfirmLogoutButton" @click="logout">Wyloguj</StyledButton>
    </template>
  </BaseModal>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'

  import BaseIcon from '@/components/BaseIcon.vue'
  import BaseModal from '@/components/BaseModal.vue'
  import { StyledButton } from '@/components/StyledButton'
  import { authService } from '@/services/authService'

  const modalVisible = ref(false)

  const showModal = () => {
    modalVisible.value = true
  }

  const closeModal = () => {
    modalVisible.value = false
  }

  const logout = () => {
    authService.deleteTokens()
    authService.redirectToLogoutPage()
  }
</script>
